import { render, staticRenderFns } from "./TransactionsTable.html?vue&type=template&id=6912cb6c&scoped=true&"
import script from "./TransactionsTable.js?vue&type=script&lang=js&"
export * from "./TransactionsTable.js?vue&type=script&lang=js&"
import style0 from "./transactions-table.scss?vue&type=style&index=0&id=6912cb6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6912cb6c",
  null
  
)

export default component.exports